<template>
	<!-- we can use functional component -->
	<div>
		<div class="wrapper wrapper-content animated fadeInRight">
			<div class="row">
				<div class="col-lg-12">
					<div class="ibox float-e-margins">
						<div class="ibox-title">
							<h4 v-if="item">
								Template settings:
							</h4>
						</div>
						<div class="ibox-content">

							<div class="row">
								<div class="enswitch-form-container col-lg-12 col-md-12 col-sm-12 col-xs-12">
									<form name="editCRMUserForm" novalidate="" class="" @submit.prevent="save()"
										v-if="!loading && !!item">
										<div class="row form-group">
											<span class="col-lg-5 col-md-5 col-sm-5 col-xs-12  control-label">Name:</span>
											<div class="col-lg-7 col-md-7 col-sm-7 col-xs-12">
												<input name="name" caption="name" v-model="item.name" type="name" />
											</div>
										</div>

										<div class="row form-group">
											<span
												class="col-lg-5 col-md-5 col-sm-5 col-xs-12  control-label">Description:</span>
											<div class="col-lg-7 col-md-7 col-sm-7 col-xs-12">
												<input name="description" caption="description" v-model="item.description"
													type="text" />
											</div>
										</div>
										<!---->
										<div v-if="!isWebhook" class="row">
											<span class="col-lg-5 col-md-5 col-sm-5 col-xs-12 ">Recording events:</span>
											<div class="col-lg-7 col-md-7 col-sm-7 col-xs-12 ">
												<!-- <input name="extension" type="text" v-model="item.extension" class="ng-pristine ng-untouched ng-valid ng-empty" validation-initialized="true" autocomplete="description"> -->
												<select v-model="item.recording_events" class="form-control">
													<option value="1">Yes</option>
													<option value="0">No</option>
												</select>
											</div>
										</div>

										<div class="row" v-if="item.webhook == '1'">
											<span class="col-lg-5 col-md-5 col-sm-5 col-xs-12 ">Event Filter:</span>
											<div class="col-lg-7 col-md-7 col-sm-7 col-xs-12 ">
												<!-- <input name="extension" type="text" v-model="item.extension" class="ng-pristine ng-untouched ng-valid ng-empty" validation-initialized="true" autocomplete="description"> -->
												<div class="add-remove">
													<select class="form-control left" multiple="multiple"
														v-model="boldedNotSelectedItems">
														<option v-for="item in notSelectedItems" v-bind:key="item.value"
															:value="item.value">{{ item.label }}</option>
													</select>
													<select class="form-control right" multiple="multiple"
														v-model="boldedSelectedItems">
														<option v-for="item in selectedItems" v-bind:key="item.value"
															:value="item.value">{{ item.label }}</option>
													</select>
													<button class="left" @click.prevent="addNotSelectedFilters">Add <i
															class="fas fa-angle-double-right"></i></button>
													<button class="right" @click.prevent="removeSelectedFilters"><i
															class="fas fa-angle-double-left"></i> Remove</button>

												</div>

											</div>
										</div>

										<div class="row" v-if="item.webhook == '1'">
											<span class="col-lg-5 col-md-5 col-sm-5 col-xs-12 ">Custom filter:</span>
											<div class="col-lg-7 col-md-7 col-sm-7 col-xs-12 ">
												<edit-query-modal v-model="mainFilter" />
											</div>
										</div>

										<div class="row" v-if="item.webhook == '1'">
											<span class="col-lg-5 col-md-5 col-sm-5 col-xs-12 ">Custom variables:</span>
											<div class="col-lg-7 col-md-7 col-sm-7 col-xs-12 ">
												<edit-custom-variables-modal :actions="logic" @change="updateLogic" />
											</div>
										</div>

										<div class="row form-group">
											<span class="col-lg-5 col-md-5 col-sm-5 col-xs-12  control-label">URL:</span>
											<div class="col-lg-7 col-md-7 col-sm-7 col-xs-12">
												<input name="url" caption="url" v-model="item.url" type="text" />
											</div>
										</div>

										<div class="row form-group" v-if="item.webhook == '1'">
											<span class="col-lg-5 col-md-5 col-sm-5 col-xs-12  control-label">Method:</span>
											<div class="col-lg-7 col-md-7 col-sm-7 col-xs-12">
												<select v-model="item.method" class="form-control">
													<!-- get post put delete -->
													<option v-for="method in validMethods" v-bind:key="method"
														:value="method">{{ method }}</option>
												</select>
											</div>
										</div>

										<div class="row form-group" v-if="item.webhook == '1'">
											<span class="col-lg-5 col-md-5 col-sm-5 col-xs-12  control-label">Example
												Templates:</span>
											<div class="col-lg-7 col-md-7 col-sm-7 col-xs-12">
												<button @click.prevent="setJSON()">JSON</button>
												<button @click.prevent="setUrlEncoded()">URL Encoded</button>
											</div>
										</div>

										<div class="row form-group">
											<span
												class="col-lg-5 col-md-5 col-sm-5 col-xs-12  control-label">Headers:</span>
											<div class="col-lg-7 col-md-7 col-sm-7 col-xs-12">
												<textarea name="headers" caption="headers" v-model="item.headers" />
											</div>
										</div>

										<div class="row form-group">
											<span
												class="col-lg-5 col-md-5 col-sm-5 col-xs-12  control-label">Template:</span>
											<div class="col-lg-7 col-md-7 col-sm-7 col-xs-12">
												<textarea name="template" caption="template" v-model="item.template" />
											</div>
										</div>
										<!---->
										<hr>
										<div class="row submit-button-container">
											<button type="submit" :disabled="sendInProgress" ref="submitbtn"
												class="btn btn-success confirm-button ladda-button edit-person-confirm vueadapt"
												data-style="zoom-out" data-spinner-size="24" data-size="s"
												data-spinner-color="white" style="display: block;">
												<span class="ladda-label">Save</span>
												<span class="fas fa-spinner fa-pulse"></span>
												<div class="ladda-progress" style="width: 0px"></div>

											</button>
										</div>
									</form>
								</div>
								<div class="webhooks-help">
									<p>
										Available &lt;#VARIABLE#&gt; template variables for webhook are:
									</p>
									<p>
										#start#, #end#, #answered#, #uniqueid#, #callid#, #stype#, #snumber#, #dtype#,
										#dnumber#, #status#, #callerid#, #callername#, #server#, #ctype#, #cnumber#,
										#recording#, #extension#, #direction#, #totaltime#, #talktime#
									</p>
								</div>
							</div>
							<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 ng-scope" style="margin-bottom: 8px;"
								ng-if="options.showProgress">
								<div v-if="loading" class="sk-spinner sk-spinner-wave ng-scope" ng-if="options.showProgress"
									style="display: block;">
									<div class="sk-rect1"></div>
									<div class="sk-rect2"></div>
									<div class="sk-rect3"></div>
									<div class="sk-rect4"></div>
									<div class="sk-rect5"></div>
								</div><!-- end ngIf: options.showProgress -->
							</div><!-- end ngIf: options.showProgress -->
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import {CustomUrlsService} from "../../services/CustomUrlsService";

import EditQueryModal from "./EditQueryModal";
import EditCustomVariablesModal from "./EditCustomVariablesModal";

export default {
	props: ["id", "isNew", "isWebhook"],
	components: {EditQueryModal, EditCustomVariablesModal},
	data: () => ({
		loading: false,
		item: null,
		sendInProgress: false,
		openList: false,
		phones: [],
		people: [],
		person: {role: 4, email: null},
		boldedNotSelectedItems: [],
		boldedSelectedItems: [],
		activeEventFilters: [],
		validMethods: ["GET", "POST", "PUT", "DELETE"],
		mainFilter: null,
		logic: []
	}),
	created() {
		let $injector = this.$root.angularInjector;

		let CoreApiService = $injector.get("CoreApiService");
		this.customUrlsService = new CustomUrlsService(CoreApiService);

		this.SwalService = $injector.get("SwalService");
		if (this.isNew) {
			this.item = {
				recording_events: "0", webhook: this.isWebhook, template: "", headers: "", method: "POST"
			};
		}
	},
	async mounted() {
		let promises = [];
		this.loading = true;
		if (!this.isNew) {
			console.info("going to load item #" + this.id);
			// let phones = await this.phonesService.getPhonesList();
			promises.push(this.loadItemToEdit());
		}
		try {
			await Promise.all(promises);
			this.loading = false;
		}
		catch (e) {
			console.error("failed to load data! error: " + e.message);
			this.loading = false;
		}
	},
	watch: {
		sendInProgress: function(val) {
			if (val) {
				this.$refs.submitbtn.dataset.loading = "";
			}
			else {
				delete this.$refs.submitbtn.dataset.loading;
			}
		}
	},
	methods: {
		async loadItemToEdit() {
			this.sourceItem = await this.customUrlsService.get(this.id);
			this.item = Object.assign({}, this.sourceItem);
			this.item.eventsFilter = !this.sourceItem.event_filter ? {events: ["answer", "calling", "hangup"]} : JSON.parse(this.sourceItem.event_filter);
			this.activeEventFilters = this.item.eventsFilter.events;
			this.mainFilter = this.item.eventsFilter.conditions;// createQueryBuilderGroup(this.item.eventsFilter.query || {});
			this.logic = this.item.eventsFilter.logic || [];
			delete this.item.id;
		},
		processParams() {
			let cloned = Object.assign({}, this.item);
			cloned.event_filter = JSON.stringify({events: this.activeEventFilters, conditions: this.mainFilter, logic: this.logic});
			cloned.webhook = this.formatIsWebhookVariable(cloned.webhook);
			delete cloned.eventsFilter;
			return cloned;
		},
		formatIsWebhookVariable(value) {
			if (value === true || value === "true" || value === 1 || value === "1") return 1;
			else return 0;
		},
		updateLogic(logic) {
			this.logic = logic;
		},
		async save() {
			// let result;
			this.sendInProgress = true;
			let itemToSend = this.processParams();
			try {
				if (this.isNew) {
					await this.customUrlsService.create(itemToSend);
				}
				else {
					await this.customUrlsService.update(this.sourceItem.id, itemToSend);
				}
				this.SwalService.popup({
					title: "Success!"
				}).then(f => {
					this.$router.replace("/list");
				});
			}
			catch (e) {
				this.SwalService.popup({
					title: getErrorMessage(e), type: "error"
				});
			}
			finally {
				this.sendInProgress = false;
			}
		},
		addNotSelectedFilters() {
			let items = this.boldedNotSelectedItems;
			this.activeEventFilters = this.activeEventFilters.concat(items);
		},
		removeSelectedFilters() {
			let items = this.boldedSelectedItems;
			this.activeEventFilters = this.activeEventFilters.filter(item => !items.includes(item));
		},
		setJSON() {
			this.item.headers = "Content-Type: application/json";
			this.item.template = `{"start":#start#,
"uniqueid":#uniqueid#,
"callid":#callid#,
"stype":"#stype#",
"snumber":"#snumber#",
"dtype":"#dtype#",
"dnumber":"#dnumber#",
"status":"#status#",
"callerid":"#callerid_external#",
"callername":"#callername#",
"server":"#server#",
"ctype":"#ctype#",
"cnumber":"#cnumber#",
"recording":"https://015pbx.net/recordings/Records/#recording#.mp3",
"end":"#end#",
"extension":"#extension#",
"direction":"#direction#",
"totaltime":#totaltime#,
"talktime":#talktime#,
"answered":#answered#}`;
		},
		setUrlEncoded() {
			this.item.headers = "Content-Type: application/x-www-form-urlencoded";
			this.item.template = "start=#start#&uniqueid=#uniqueid#&callid=#callid#&stype=#stype#&snumber=#snumber#&dtype=#dtype#&dnumber=#dnumber#&status=#status#&callerid=#callerid_external#&callername=#callername#&server=#server#&ctype=#ctype#&cnumber=#cnumber#&recording=https://015pbx.net/recordings/Records/#recording#.mp3&end=#end#&extension=#extension#&direction=#direction#&totaltime=#totaltime#&talktime=#talktime#&answered=#answered#";
		}
	},
	computed: {
		selectedItems() {
			// console.info("eventsFilter", this.item.eventsFilter);
			// return this.activeEventFilters.map(item => options.find(option => item == option.value));
			return options.filter(opt => this.activeEventFilters.includes(opt.value));
		},
		notSelectedItems() {
			// console.info("eventsFilter", this.item.eventsFilter);
			return options.filter(opt => !this.activeEventFilters.includes(opt.value));
		}
	}
};

let options = [
	{label: "Abandon", value: "abandon"},
	{label: "Leave", value: "leave"},
	{label: "Join", value: "join"},
	{label: "ReJoin", value: "rejoin"},
	{label: "Queue Callback", value: "queuecallback"},
	{label: "Complete Agent", value: "completeagent"},
	{label: "Complete Caller", value: "completecaller"},
	{label: "Pause", value: "pause"},
	{label: "UnPause", value: "unpause"},
	{label: "Login", value: "login"},
	{label: "Logout", value: "logout"},
	{label: "Calling", value: "calling"},
	{label: "Hangup", value: "hangup"},
	{label: "Hangup Answered Only", value: "hangupansweredonly"},
	{label: "Answer", value: "answer"},
	{label: "Transfer", value: "transfer"},
	{label: "Incoming SMS", value: "incomingsms"},
	{label: "Failed Callback", value: "callback_failed"}
];

function getErrorMessage(e) {
	if (e.message == "Bad request") {
		if (e.key == "error_username_in_use") {
			return "Duplicate username";
		}
		else if (e.key == "error_email_exists") {
			return "Duplicate email";
		}
	}
	return e.message || e.statusText || e || "Error";
}
</script>

<style lang="scss" scoped>
.webhooks-help {
	padding-top: 2em;
}

.add-remove .left {
	float: left;
	width: 48%;
	margin-right: 1%;
}

.add-remove .right {
	float: left;
	width: 48%;
}
</style>
